// extracted by mini-css-extract-plugin
export default {"button":"ShowDetailsLabel_button__PzvDM","content":"ShowDetailsLabel_content__R9yTy","skeletonLoadingAnimation":"ShowDetailsLabel_skeletonLoadingAnimation__pw3TW"};